import React, { useContext, useEffect, useState } from "react";

import { Button, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import InfoPill from "../InfoPill";
import { ShimmerTable } from "react-shimmer-effects";
import schoolApi from "../../api/schoolApi";
import CreateSyllabusModel from "./CreateSyllabusModel";
import Confirm from "../Confirm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePermissions } from "../contexts/PermissionContext";
import { Helmet } from "react-helmet";
import { SessionContext } from "../SessionProvider";

const SyllabusList = (props) => {
  const { selectedSessionId, setSelectedSessionId, currentSessionId } =
    useContext(SessionContext);
    const [isCurrentSession,setIsCurrentSession] = useState();

  const { rolePermissions, userInfo } = usePermissions();

  const [body, setBody] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [btnName, setBtnName] = useState("Save");
  const [syllabusData, setSyllabusData] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowDataId, setRowDataId] = useState();
  const canCreate = rolePermissions?.Syllabus_List?.can_create;
  const canEdit = rolePermissions?.Syllabus_List?.can_edit;
  const canDelete = rolePermissions?.Syllabus_List?.can_delete;

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId,isCurrentSession]);

  useEffect(() => {
    fetchAllSyllabus();
  }, [selectedSessionId]); // Re-run when session ID changes

  async function fetchAllSyllabus() {
    try {
      const result = await schoolApi.getAllSyllabus();

      if (result !== "No Data Found" && Array.isArray(result)) {
        const filteredSyllabus = result.filter(
          (item) => item.session_id === selectedSessionId
        );

        setBody(filteredSyllabus);
      } else {
        setBody([]);
      }
    } catch (error) {
      console.error("Error fetching syllabus:", error);
    }
  }

  const handleEditButton = (row) => {
    setModalShow(true);
    setSyllabusData(row);
    setBtnName("Update");
  };

  const handleDeleteButton = (row) => {
    setShowDeleteModal(true);
    setRowDataId(row.id);
  };

  const header = [
    {
      title: "Class Name",
      prop: "class",
      isFilterable: true,
      show: true,
      cell: (row) => (
        <Link to={"/syllabusview/" + row.id} state={row}>
          {row.class}
        </Link>
      ),
    },
    { title: "Section", prop: "section", isFilterable: true, show: true },
    { title: "Subject", prop: "subject", isFilterable: true, show: true },
    { title: "Status", prop: "isactive", isFilterable: true, show: true },
    {
      title: "Action",
      prop: "isactive",
      isFilterable: true,
      show: true,
      cell: (row) => {
        return (
          <>
            {(userInfo?.userrole === "SYS_ADMIN" ||
              userInfo?.userrole === "ADMIN" ||
              canEdit) && (
              <Button
                className="btn-sm mx-2 edit-button"
                variant=""
                onClick={() => handleEditButton(row)}
                disabled={isCurrentSession === false?true:false}
              >
                <i className="fa-regular fa-pen-to-square"></i>
              </Button>
            )}
            {(userInfo?.userrole === "SYS_ADMIN" ||
              userInfo?.userrole === "ADMIN" ||
              canDelete) && (
              <button
                className="btn btn-sm btn-danger mx-2"
                onClick={() => handleDeleteButton(row)}
                disabled={isCurrentSession === false?true:false}
              >
                <i className="fa fa-trash"></i>
              </button>
            )}
          </>
        );
      },
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const createSyllabus = () => {
    setModalShow(true);
    setSyllabusData("");
    setBtnName("Save");
  };

  const handleCloseModal = () => {
    setModalShow(false);
  };

  const handleDeleteSyllabusRecord = async () => {
    if (rowDataId) {
      try {
        const result = await schoolApi.deleteSyllabus(rowDataId);
        if (result.success) {
          fetchAllSyllabus();
          setShowDeleteModal(false);
          return toast.success(result.message);
        } else {
          return toast.error("Something went wrong");
        }
      } catch (error) {
        return toast.error("Internal server error");
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      {showDeleteModal && (
        <Confirm
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          handleDeleteButton={() => handleDeleteSyllabusRecord()}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="deleteSyllabus"
        />
      )}

      <CreateSyllabusModel
        modalShow={modalShow}
        handleCloseModal={handleCloseModal}
        fetchAllSyllabus={fetchAllSyllabus}
        syllabusData={syllabusData}
        btnName={btnName}
      />

      {/* <Helmet><title>{props?.tabName}</title> </Helmet>
    <PageNavigations   colLg={2} colClassName="d-flex mx-4 " extrColumn={12}/> */}
      <Col lg={2} className="mx-2">
        <Link className="nav-link" to="/">
          Home <i className="fa-solid fa-chevron-right"></i> Syllabus
        </Link>
      </Col>

      <Row className="g-0">
        <Col lg={12} className="px-lg-4">
          {body ? (
            <DatatableWrapper
              body={body ? body : ""}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={3}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={5}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  <div style={{ marginTop: "5px" }}>
                    <InfoPill left="Total Syllabus" right={body?.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  {(userInfo?.userrole === "SYS_ADMIN" ||
                    userInfo?.userrole === "ADMIN" ||
                    canCreate) && (
                    <Button
                      className="btn add-new-button"
                      variant=""
                      onClick={() => createSyllabus()}
                      disabled={isCurrentSession === false?true:false}
                    >
                      New Syllabus
                    </Button>
                  )}
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default SyllabusList;
